import apiClient from "api-client";

import getWrappedUseQuery from "../../helpers/getWrappedUseQuery";
import KEYS from "../keys";

export const useGetForumFeedbackExportQuery = getWrappedUseQuery(
  KEYS.GET_FORUM_FEEDBACK_EXPORT,
  apiClient.forumFeedback.export.get,
);
